<template>
	<div>
		<div class="menuTool" style="width:100%;">
			<div class="search-title">
				应缴列表
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.payMeterNo" placeholder="请输入表号" clearable></el-input>
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.roomName" placeholder="请输入房间号" clearable></el-input>
			</div>
			<div class="search-input-item">
				<dict-select size="small" v-model="query.meterType" placeholder="仪表类型" :dict="meterType" clearable></dict-select>
			</div>
			<div class="search-input-item">
				<dict-select size="small" v-model="query.payStatus" placeholder="销帐状态" :dict="writeOffStatusFlag" clearable></dict-select>
			</div>
			<div class="search-input-item">
				<el-date-picker
					v-model="query.dataRange"
					type="daterange"
					align="right"
					size="small"
					style="width: 410px"
					value-format="yyyyMM"
					unlink-panels
					range-separator="至"
					start-placeholder="开始期数"
					end-placeholder="结束期数"
					:picker-options="pickerOptions"
				>
				</el-date-picker>
			</div>
			<div class="search-button-tools">
				<el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.order.listPagePayable'" :loading="tableLoading" @click="doSearch">查询</el-button>
				<el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.order.exportPayableList'" @click="doExport">导出</el-button>
			</div>
			<el-table :data="tableData" row-key="id" border v-loading="tableLoading" tooltip-effect="light" :stripe="true">
				<el-table-column width="200" show-overflow-tooltip prop="payMeterNo" label="表号"></el-table-column>
				<el-table-column width="100" prop="meterType" label="类型"></el-table-column>
				<el-table-column width="100" show-overflow-tooltip prop="roomName" label="房间号"></el-table-column>
				<el-table-column width="150" show-overflow-tooltip prop="roomCusName" label="业主名"></el-table-column>
				<el-table-column width="120" prop="accrualDate" label="应收日期"></el-table-column>
				<el-table-column width="120" prop="beforeNum" label="上期读数" align="right"></el-table-column>
				<el-table-column width="120" prop="nowNum" label="本期读数" align="right"></el-table-column>
				<el-table-column width="120" prop="beilv" label="倍率"></el-table-column>
				<el-table-column width="120" prop="price" label="单价（元）" align="right"></el-table-column>
				<el-table-column width="100" prop="loss" label="线损"></el-table-column>
				<el-table-column width="100" prop="useNum" label="用量" align="right"></el-table-column>
				<el-table-column width="120" prop="money" label="金额（元）" align="right"></el-table-column>
				<el-table-column width="200" prop="chargeStartDate" label="计费开始日期"></el-table-column>
				<el-table-column width="200" prop="chargeEndDate" label="计费结束日期"></el-table-column>
				<el-table-column width="200" prop="createDate" label="录入日期"></el-table-column>
				<el-table-column width="120" prop="createByStr" label="录入人"></el-table-column>
				<el-table-column width="100" prop="payStatusStr" label="销帐状态"></el-table-column>
			</el-table>
			<simple-pagination @search="doSearch" />
		</div>
	</div>
</template>

<script>
import "@/assets/scss/common.scss";
import { meterType, writeOffStatusFlag } from "@/dict/meterDict";
import mixin from "@/mixin";
import { pick, assign } from "lodash";

export default {
	name: "ShouldPayTable",
	mixins: [mixin],
	props: {
		parentData: {
			type: Object,
			default: function() {
				return {};
			},
		},
	},
	data() {
		return {
			meterType,
			writeOffStatusFlag,
			queryListUrl: "/meter/web/handwork/listPagePayable",
		};
	},
	methods: {
		doSearch() {
			this.getList();
		},
		doExport() {
			const title = "应缴费账单列表";
			const url = "/meter/web/handwork/exportPayableList";
			this._export(title, url);
		},
		selectNode(data) {
			this.query = assign(this.query, data);
			this.doSearch();
		},
	},
	watch: {
		parentData(val) {
			this.query = assign(this.query, this.parentData);
			this.doSearch();
		},
	},
	mounted() {
		this.query = assign(this.query, this.parentData);
		this.doSearch();
	},
};
</script>
